import { Box } from '@mui/material';

export default function SendCommentContainer({ children }) {
  return (
    <Box
      sx={(theme) => ({
        border: '1px #2C2C2E solid',
        borderRadius: '8px',
        padding: '16px',
        borderColor: theme.palette.grey.A400,
      })}
    >
      {children}
    </Box>
  );
}
